import React from "react";
import MaterialTable from "material-table";
import { MaterialGrid } from '../../styles/StyleComponents';
import { PropTypes } from 'prop-types';

// Parametros props
//data: datos del Grid []
//columns: columnas de la tabla []
//selectedRow: Fila seleccionada 
//actions: Botones y funciones del grid []
//selection: Valida si se muestra o no los checks de seleccion (true o false)
//title: Titulo de la tabla ""
//pageSize: El número de registros por pagina de la vista
//showTitle: Muestro o no el titulo de la tabla
//pageSizeOptions: Opciones de numero de registro de paginados []
//minBodyHeight: Altura mínima del cuerpo de la tabla (por defecto 0 para ajustar al contenido)
//maxBodyHeight: Altura máxima del cuerpo de la tabla (undefined para sin límite)
//autoHeight: Ajusta automáticamente el pageSize al número de registros para evitar espacios vacíos (false por defecto)

MaterialTableCS.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  actions: PropTypes.array.isRequired,
  selection: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  pageSize: PropTypes.number.isRequired,
  showTitle: PropTypes.bool.isRequired,
  pageSizeOptions: PropTypes.array.isRequired,
  toolbar: PropTypes.bool.isRequired,
  minBodyHeight: PropTypes.number,
  maxBodyHeight: PropTypes.number,
  autoHeight: PropTypes.bool
};

MaterialTableCS.defaultProps = {
  data: [],
  columns: [],
  actions: [],
  selection: false,
  title: "Título por Default",
  pageSize: 10,
  showTitle: false,
  pageSizeOptions: [5, 10, 25, 50, 500],
  paging: true,
  toolbar: true,
  columnsButton: false,
  sorting: true,
  minBodyHeight: 0,
  maxBodyHeight: undefined,
  autoHeight: false
}

function MaterialTableCS(props) {
  // Calcular pageSize dinámico si autoHeight está habilitado
  const getEffectivePageSize = () => {
    if (props.autoHeight && props.data && props.data.length > 0) {
      // Si hay menos datos que el pageSize, usar la cantidad de datos
      // Si hay más datos, usar el pageSize original
      return Math.min(props.data.length, props.pageSize);
    }
    return props.pageSize;
  };

  // Determinar si mostrar paginación
  const getEffectivePaging = () => {
    if (props.autoHeight && props.data && props.data.length <= props.pageSize) {
      return false; // Ocultar paginación si todos los datos caben en una página
    }
    return props.paging;
  };

  return (
    <MaterialTable
      title={props.title}
      columns={props.columns}
      tableRef={props.tableRef}
      data={props.data}
      editable={props.editable}
      cellEditable={props.cellEditable}
      onRowClick={props.onRowClick}
      localization={{
        body: MaterialGrid.Body,
        grouping: MaterialGrid.Group,
        header: { actions: " " },
        pagination: MaterialGrid.Pagination,
        toolbar: MaterialGrid.Toolbar,
      }}
      options={{
        filtering: props.filtering,
        headerStyle: MaterialGrid.headerStyle,
        exportButton: true,
        columnResizable: true,
        columnsButton: props.columnsButton,
        rowStyle: (rowData) => ({
          backgroundColor:
            props.selectedRow === rowData.tableData.id ? "#EEE" : "#FFF",
        }),
        sorting: false,
        pageSize: getEffectivePageSize(),
        selection: props.selection,
        pageSizeOptions: props.pageSizeOptions,
        showTitle: props.showTitle,
        tableLayout: "auto",
        draggable: true,
        paginationType: 'normal',
        search: props.search,
        paging: getEffectivePaging(),
        toolbar: props.toolbar, // <- toolbar es ahora opcional
        minBodyHeight: props.minBodyHeight || 0, // Controla la altura mínima del cuerpo de la tabla
        maxBodyHeight: props.maxBodyHeight, // Controla la altura máxima del cuerpo de la tabla
      }}
      actions={props.actions}
      components={props.components}
      style={{ width: "100%" }}
    />
  )
}

export default React.memo(MaterialTableCS);